import React, { useMemo } from 'react';
import { SingleBillId } from 'utils/api/models/bills/singleBillId';
import SearchRow from './common/SearchRow';
import classNames from 'classnames';
import CustomSearch from 'components/CustomSearch/CustomSearch';
import { translate } from 'components/Translation';
import styles from 'assets/jss/material-dashboard-pro-react/views/services/addLineDialogStyle';
import { makeStyles } from '@material-ui/core';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IBillingAccountTabProps {
	billingAccounts: SingleBillId[];
	selectedBillingAccount: types.newServices.IBillingId | null;
	setSelectedBillingAccount: React.Dispatch<React.SetStateAction<types.newServices.IBillingId | null>>;
}

const BillingAccountTab = ({
	billingAccounts,
	setSelectedBillingAccount,
	selectedBillingAccount,
}: IBillingAccountTabProps) => {
	const classes = useStyles();

	const extendedBillingAccounts = useMemo(() => {
		return billingAccounts.map((billingAccount, index) => ({
			id: `${billingAccount.billingId}${index}`,
			accountId: billingAccount.accountId,
			billingId: billingAccount.billingId,
			value: `${billingAccount.billingAccountName} / ${billingAccount.billingId}`,
			content: <SearchRow text={`${billingAccount.billingAccountName} / ${billingAccount.billingId}`} />,
		}));
	}, [billingAccounts]);

	return (
		<div className={classNames(classes.tabWrapper)}>
			<div className={classes.smWidth}>
				<CustomSearch
					elements={extendedBillingAccounts}
					id="billingAccountsSearch"
					label={translate('new.services.billing.account.name')}
					elementSelected={(billingAccount) => setSelectedBillingAccount(billingAccount)}
					selectedElement={selectedBillingAccount}
				/>
			</div>
		</div>
	);
};

export default BillingAccountTab;
